<template>
  <de-layout-content>
    <el-form :model="queryParams" ref="queryForm" :inline="true" class="ant-advanced-search-form" size="small">
      <el-form-item label="用户信息" prop="keyWord">
        <el-input v-model="queryParams.keyWord" placeholder="姓名/联系电话/邮箱" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="账号状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="账号状态" clearable :popper-append-to-body="true">
          <el-option placeholder="选择状态" v-for="(item, index) in userType" :key="index" :label="item.name"
            :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="所在部门" style="margin-left: 15px;">
        <el-select v-model="queryParams.organizationId" placeholder="选择所在部门">
          <el-option v-for="item in treeList" :key="item.label" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间" prop="time">
        <el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button v-permission="['user:add']" type="primary" icon="el-icon-plus" @click="addAction">
          {{ $t("user.create") }}
        </el-button>
      </el-form-item>

    </el-form>

    <div>
      <!-- 数据列表 -->
      <el-table element-loading-text="加载中" :data="list" style="width: 100%">
        <el-table-column label="姓名" align="center" prop="name" width="150" fixed="left" />
        <el-table-column label="用户类型" align="center" prop="type" width="120">
          <template slot-scope="scope">
            机构管理员
<!--            <div v-if="scope.row.type == 8" style="color: #67C23A">● {{ userTypeObj[scope.row.type] }}</div>-->
<!--            <div v-else>{{ userTypeObj[scope.row.type] }}</div>-->
          </template>
        </el-table-column>
        <el-table-column label="用户角色" align="center" prop="roleName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="性别" align="center" prop="sex">
          <template slot-scope="scope">
            <div>{{ scope.row.sex == 1 ? "男" : "女" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="年龄" align="center" prop="age"> </el-table-column>
        <el-table-column label="手机号码(登录账号)" align="center" prop="phone" width="150" />
        <el-table-column label="所在部门" align="center" prop="organization" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="display: block" v-for="item in scope.row.deptNames">{{ item.organizationName }}</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="民族" align="center" prop="ethnicGroup"> </el-table-column>-->
        <el-table-column label="职务" align="center" prop="positionName" show-overflow-tooltip>
        </el-table-column>
<!--        <el-table-column label="直接上级" align="center" prop="deptUser">-->
<!--          <template slot-scope="scope">-->
<!--            <span style="display: block" v-for="item in scope.row.deptUser">{{ item.name }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="入职时间" align="center" prop="workingTime">
          <template slot-scope="scope">
            {{ scope.row.workingTime?moment(scope.row.workingTime).format('YYYY-MM-DD HH:mm'):'' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="status">
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-circle-check" style="color: #67C23A;font-size: 24px"></i>
            <i v-if="scope.row.status == -1" class="el-icon-circle-close" style="color: #F56C6C;font-size: 24px"></i>
<!--            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="-1" @change="changeStatusHandle(scope.row)"></el-switch>-->
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="">
              <!-- <el-button
                size="small"
                plain
                type="success"
                @click="goEdit(scope.row)"
                >编辑</el-button
              > -->

              <el-button size="small" plain type="success" @click="editAction(scope.row)">编辑</el-button>

              <el-button size="small" plain type="danger" @click="deleteUser(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="paginationConfig.total" :page.sync="paginationConfig.currentPage"
        :limit.sync="paginationConfig.pageSize" @pagination="getList" />
    </div>

    <!-- <user-editer ref="userEditer" @saved="search" /> -->
    <el-dialog :title="formData.id ? '编辑操作员' : '新增操作员'" :visible.sync="dialogFormVisible" width="780px">
      <el-form :model="formData" inline="true" label-width="80px" style="width: 100%" ref="formData" :rules="rules">
        <!-- <el-row :gutter="24">
          <el-col :span="12">
          </el-col>
          <el-col :span="12">
          </el-col>
        </el-row> -->
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="照片" prop="headImageUrl">
              <uploadImg :ImgUrl="formData.headImageUrl" @imgCallback="(url) => imgCallback(url, 'headImageUrl')">
              </uploadImg>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="formData.phone" autocomplete="off" placeholder="输入手机号" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="formData.name" autocomplete="off" placeholder="输入姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属组织" prop="organizationId">
              <el-popover placement="bottom" popper-class="user-popper dept" width="217" trigger="click"
                          v-model="popoverVisible">
                <el-tree class="filter-tree" :data="treeList" :props="defaultProps" ref="tree"
                         @node-click="handleNodeClick">
                </el-tree>

                <el-select slot="reference" v-model="formData.organizationId" class="de-form-sex-select"
                           popper-class="tree-select" placeholder="请选择所属组织" style="width: 206px" @change="getRoleOptions">
                  <el-option v-for="item in treeList" :key="item.label" :label="item.name" :value="item.id" />
                </el-select>
              </el-popover>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户角色" prop="roleIds">
              <el-select v-model="formData.roleIds" placeholder="请选择用户角色" :disabled="!formData.organizationId" style="width: 206px">
                <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCardNo">
              <el-input v-model="formData.idCardNo" autocomplete="off" maxlength="18" @change="idInput"
                placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入队时间" prop="workingTime">
              <el-date-picker v-model="formData.workingTime" type="date" placeholder="请选择入队时间" style="width: 206px">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="职务">
              <el-select v-model="formData.postId" clearable filterable placeholder="请选择职务" style="width: 206px">
                <el-option v-for="pos in positionOptions" :key="pos.postId" :label="pos.postName"
                  :value="pos.postId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
          <el-input v-model="formData.email" autocomplete="off" prop="email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="微信账号">
          <el-input v-model="formData.wechat" autocomplete="off" prop="wechat" placeholder="请输入微信账号"></el-input>
        </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" required>
              <el-radio-group v-model="formData.status" style="width: 202px">
                <el-radio-button :label="1">正常</el-radio-button>
                <el-radio-button :label="-1">禁止</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="性别" required>
              <el-radio-group v-model="formData.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item :label="$t('commons.remark')" prop="textarea" style="width: 100%;">
              <el-input v-model="formData.remark" type="textarea" placeholder="请输入备注" style="width: 567px" />
            </el-form-item>
          </el-col>
        </el-row>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formData')">确 定</el-button>
      </div>
    </el-dialog>




  </de-layout-content>
</template>

<script>
import moment from "moment";
import { getMemberList } from "@/api/train/member"
import userEditer from "./UserEditer.vue";
import { columnOptions } from "./options";

import { addOrder, formatOrders } from "@/utils/index";
import { buildParam } from "@/utils/GridConditionUtil";
import { Base64 } from "js-base64";
import {
  userLists,
  delUser,
  editStatus,
  allRoles,
  addUser,
  editUser,
} from "@/api/system/user";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import { structureList } from "@/api/system/mechanism";
import { mapGetters } from "vuex";
import _ from "lodash";
import {memberInfo} from "@/api/member/member";
export default {
  components: {
    uploadImg,
  },
  data() {
    return {
      dialogFormVisible: false,
      popoverVisible: false,
      rules: {
        phone: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          { min: 11, max: 11, message: "长度在11个字符", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        organizationId: [
          { required: true, message: "请选择所属组织", trigger: "change" },
        ],
        roleIds: [
          { required: true, message: "请选择用户角色", trigger: "change" },
        ],
      },
      userTypeObj: {
        1: '超级管理员',
        8: '机构管理员',
      },
      list: [],
      roleList: [],
      roleOptions: [],
      departmentOption: [],
      treeList: [],
      selectDepts: [],
      queryParams: {
        time: [],
      },
      formData: {
        headImageUrl: null,
        sex: 1,
        status: 1,
        roleIds: "",
      },
      userType: [
        {
          id: 1,
          name: "正常",
        },
        {
          id: -1,
          name: "禁用",
        },
      ],
      paginationConfig: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      defaultProps: {
        children: "child",
        label: "name",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {},
  created() {
    this.getList();
    this.getRoleList();
    this.getStructureList();
  },
  mounted() { },
  beforeCreate() { },
  destroyed() { },
  methods: {
    moment,
    getList() {
      this.loading = true;
      const { currentPage, pageSize } = this.paginationConfig;
      let params = {
        ...this.queryParams,
        startTime: this.queryParams.time.length
          ? moment(this.queryParams.time[0]).valueOf()
          : "",
        endTime: this.queryParams.time.length
          ? moment(this.queryParams.time[1]).valueOf()
          : "",
        pageNum: currentPage,
        pageSize: pageSize,
        type: 8
      };
      getMemberList(params).then((res) => {
        console.log(res, "res");
        this.list = res.data.list;
        this.paginationConfig.total = res.data.total;
      });
    },
    getRoleOptions(){
      this.formData.roleIds = null
      allRoles({organizationId:this.formData.organizationId}).then(res => {
        this.roleOptions = res.data
      })
    },
    getRoleList() {
      allRoles().then((res) => {
        console.log(res);
        this.roleList = res.data;
      });
    },
    getStructureList() {
      structureList({
        name: undefined,
        status: 1,
      }).then((res) => {
        this.treeList = res.data;
      });
    },
    imgCallback(imgUrl, key) {
      this.$nextTick(() => {
        this.$set(this.formData, "headImageUrl", imgUrl);
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children 若为空数组，则将 children 设为undefined
          data[i].child = undefined;
        } else {
          // children 若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].child);
        }
      }
      return data;
    },
    changeSwitch(row) {
      const { userId, status } = row;
      const param = {
        userId: userId,
        status: status,
      };
      editStatus(param).then((res) => {
        this.$success(this.$t("commons.modify_success"));
        this.getList();
      });
    },

    handleNodeClick(data) {
      console.log(data);
      this.selectDepts = [
        {
          ...data,
        },
      ];
      this.$set(this.formData, "organizationId", data.id);
      // this.formData.organizationId = data.id;
      this.$set(this.formData, "usersGroupList",
        [{
          organizationId: data.id,
          teamId: null,
          groupId: null
        }]
      );

      // this.formData.organizationId = data.id;

      this.popoverVisible = false;
      console.log(this.selectDepts, "selectDepts");
      this.getRoleOptions()
    },

    handleQuery() {
      this.paginationConfig.currentPage = 1;
      this.getList();
    },
    resetQuery() {
      // this.$refs["queryForm"].resetFields();
      this.queryParams = {
        time: [],
      };
      this.handleQuery();
    },
    addAction() {
      this.formData = {
        sex: 1,
        status: 1,
        type:8,
        isAddUser: 1,
        usersGroupList:[
        {
            organizationId: this.formData.organizationId,
            teamId: null,
            groupId: null
        }],
        roleIds: "",
      };
      this.$nextTick(() => {
        this.$refs["formData"].clearValidate();
      });
      this.getRoleOptions()
      this.dialogFormVisible = true;
    },
    editAction(row) {
      this.formData = {}
      memberInfo(row.id).then(res => {
        if(res.code == 200) {
          this.formData = {
            type: res.data.type,
            id: res.data.id,
            headImageUrl: res.data.headImageUrl,
            phone: res.data.phone,
            name: res.data.name,
            roleIds: res.data.roleIds[0],
            organizationId: res.data.organizationId,
            idCardNo: res.data.idCardNo,
            workingTime: res.data.workingTime,
            postId: res.data.postId,
            email: res.data.email,
            wechat: res.data.wechat,
            status: res.data.status,
            sex: res.data.sex,
            remark: res.data.remark,
            usersGroupList:[
              {
                organizationId: res.data.organizationId,
                teamId: null,
                groupId: null
              }]
          }
          this.getRoleOptions()
          this.dialogFormVisible = true;
        }
      })
    },

    create() {
      this.$refs.userEditer.init();
    },
    submitForm(formName) {
      console.log('1111')
      console.log(this.formData)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          let data = {
            ...this.formData,
            roleIds: [this.formData.roleIds]
          };
          console.log(data, "data");
          if (data.id) {
            // 编辑
            editUser(data).then((res) => {
              console.log(res);
              this.dialogFormVisible = false;
              this.getList();
            });
          } else {
            addUser(data).then((res) => {
              console.log(res);
              this.dialogFormVisible = false;
              this.getList();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteUser(row) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          delUser(encodeURIComponent(row.id)).then((res) => {
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.table-container {
  height: calc(100% - 50px);

  .mar16 {
    margin: 0 -2px 0 4px;
  }

  .mr2 {
    margin-left: -3px;
  }
}

.table-container-filter {
  height: calc(100% - 110px);
}
</style>
<style lang="scss">
.reset-pwd-icon {
  margin-top: 4px;
  color: rgb(255, 153, 0);
}

.reset-pwd {
  padding: 20px 24px !important;
  display: flex;
  flex-wrap: wrap;

  .tips {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    margin-left: 8.67px;
    color: #1890FF;
  }

  i {
    font-size: 14.666666030883789px;
    color: #ff8800;
    line-height: 22px;
  }

  .editer-form-title {
    margin: 4px 0 16px 24px;

    .pwd,
    .btn-text {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
    }

    .pwd {
      margin-right: 8px;
      color: #1890FF;
    }

    .btn-text {
      border: none;
    }
  }

  .foot {
    text-align: right;
    width: 100%;

    .btn {
      border-radius: 4px;
      padding: 4px 12px 4px 12px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: center;
      border: none;
      box-sizing: border-box;
    }

    .normal {
      color: #1890FF;
      border: 1px solid #bbbfc4;
      margin-left: 12px;
    }
  }
}

.list-columns-select {
  padding: 8px 11px !important;
  width: 238px;

  .title,
  .el-checkbox {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    padding: 5px 0;
    margin: 0;
    color: #8f959e;
  }

  .el-checkbox {
    color: #1890FF;
    width: 100%;
  }
}

.de-one-line {
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.de-table-tooltips {
  max-width: 200px;
}

// el-radio-button el-radio-button--medium is-active
.el-dialog .el-dialog__body .el-form-item .el-form-item__content .el-radio-group label.el-radio-button.is-active span {
  background-color: #1890FF !important;
  border: 1px solid #1890FF !important;
}
</style>
